import React from "react";
import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";

const products = [
  {
    id: 1001,
    name: "Ladies Fancy Rimless Sunglasses With Gradient Lenses - Gold Frame / Black Lens",
    price: 750,
    image: "/image/shop/SunglassesRimless.jpeg",
  },
  {
    id: 1002,
    name: "HX-T90 Ultra Bright Rechargeable LED Headlight – Multi-Mode Waterproof Headlamp with Magnetic Function & Type-C Fast Charging",
    price: 950 ,
    image: "/image/shop/Bright Rechargeable LED.png",
  },
  {
    id: 1003,
    name: "DIGITAL HANGING SCALE 50kg ABS LCD Display Strap Travel Multifunctional Digital Luggage Weighing Scales",
    price: 800,
    image: "/image/shop/Digital wighting scales.jpg",
  },
  {
    id: 1004,
    name: "WAGLOK Slim Tuck Lock Wallet with ID Window & Cash Pocket - Brown",
    price: 300,
    image: "/image/shop/Slim Tuck Lock Wallet.png",
  },
  {
    id: 1005,
    name: "7.5% nHAP White Tooth Repair Hydroxyapatite Toothpaste – Advanced Enamel Whitening & Stain Reduction (120g)",
    price: 350,
    image: "/image/shop/White Tooth Repair.png",
  },
  {
    id: 1006,
    name: "Women’s Leather Tote Bag With Zipper Pocket Master Quality Stylish And Durable Fashion",
    price: 1600,
    image: "/image/shop/Leather Tote Bag.jpeg",
  },
  {
    id: 1007,
    name: "Timilk Regenscar Stem Cell Scar Gel 20g Triple Action Formula For Old And New Scars Surgical Marks Skin Renewal",
    price: 400,
    image: "/image/shop/Timilk Regenscar Stem Cell Scar Gel.png",
  },
  {
    id: 1008,
    name: "Next Nova Imported 10 Portable Air Cooler Fan – 3-in-1 Mini AC Desktop Humidifier 7-Color LED",
    price: 2200,
    image: "/image/shop/Portable Air Cooler Fan.jpg",
  },
  {
    id: 1009,
    name: "Heavy-Duty Combination Pliers – Professional Grip Hand Tool 8 InchGaming Chair",
    price: 550,
    image: "/image/shop/Professional Grip Hand Tool 8 Inch.png",
  },
  {
    id: 1010,
    name: "Heavy Duty Manual Steel Nail Gun Set – Portable Concrete Wall Fastening Tool with Accessories",
    price: 4400,
    image: "/image/shop/Heavy Duty Manual Steel Nail Gun Set.png",
  },
  {
    id: 1011,
    name: "Heavy Duty 9 In 1 Multi Function Pliers Nail Pry Wire Stripper Cutter CR V Steel Professional Tool",
    price: 1125,
    image: "/image/shop/Heavy Duty 9 In 1 Multi Function Pliers Nail.jpeg",
  },
  {
    id: 1012,
    name: "New Design Long Wallet for Men & Women | 12 Card Slots | Half Zip Pocket - Black",
    price: 480,
    image: "/image/shop/New Design Long Wallet.jpg",
  },
  {
    id: 1013,
    name: "Balebaily Long Wallet for Men & Women with Zipper Pocket - Black",
    price: 801,
    image: "/image/shop/Balebaily Long Wallet.png",
  },
  {
    id: 1014,
    name: "750ml Sports Water Bottle – Leakproof BPA-Free Gym & Fitness Drinking Bottle | Random Color",
    price: 975,
    image: "/image/shop/750ml Sports Water Bottle.jpeg",
  },
  {
    id: 1015,
    name: "Leakproof Replacement Lid Compatible with 40oz Tumblers | Random Color",
    price: 510,
    image: "/image/shop/Leakproof Replacement Lid Compatible.jpeg",
  },
  {
    id: 1016,
    name: "Peva Material Universal Electric Fan Dust Cover Prevent Aging Of Fan Blades Circular Electric Fan Sleeve Electric Fan Cover(random design )",
    price: 370,
    image: "/image/shop/Peva Material Universal Electric Fan Dust Cover.jpg",
  },
  {
    id: 1017,
    name: "Premium SZM 750ml Stainless Steel Water Bottle Leakproof | Random Color",
    price: 1751,
    image: "/image/shop/Premium SZM 750ml Stainless Steel Water Bottle Leakproof.jpeg",
  },
  {
    id: 1018,
    name: "ACNIX Anti Acne Face Wash Deep Cleansing Formula With Benzoyl Peroxide And Aloe Vera 120 ml",
    price: 910,
    image: "/image/shop/ACNIX Anti Acne Face Wash Deep Cleansing.png",
  },
  {
    id: 1019,
    name: "Acrylic Mirror Ayat ul Kursi Car Hanging Decor – Black & Golden Islamic Rear View Mirror Pendant | Size: 12 × 8",
    price: 480,
    image: "/image/shop/Acrylic Mirror Ayat ul Kursi Car Hanging Decor.jpeg",
  },
  {
    id: 1020,
    name: "Regal Steel Body Hot And Cold Water Cooler 10 Liter With Temperature Control And Elegant Floral Design",
    price: 8470,
    image: "/image/shop/Regal Steel Body Hot And Cold Water Cooler.png",
  },
  {
    id: 1021,
    name: "Set of 3 Premium Wall Art Photo Tiles – Modern Home Decor Sets",
    price: 335,
    image: "/image/shop/RAF Professional Electric Coffee & Spice Grinder – 300W High-Power Stainless Steel Masala Grinder.png ",
  },
  {
    id: 1022,
     name: "2-In-1 Universal Cup Phone Drinks Holder Bicycle Adjustable Cell Phone Holder Water Bottle Multifunctional Universal Cup Holder",
    price: 855,
    image: "/image/shop/2-In-1 Universal Cup Phone Drinks Holder.jpeg",
  },
  {
    id: 1023,
    name: "Malina Embroidered Luxury Lawn Unstitched 3Pc Suit – Ice Blue Floral Digital Print with Chiffon Dupatta",
    price: 3231,
    image: "/image/shop/Malina Embroidered Luxury Lawn Unstitched 3Pc Suit.jpg",
  },
  {
    id: 1024,
   name: "RAF Professional Electric Coffee & Spice Grinder – 300W High-Power Stainless Steel Masala Grinder",
    price: 1180,
   image: "/image/shop/RAF Professional Electric Coffee & Spice Grinder – 300W High-Power Stainless Steel Masala Grinder.png",
  },
  {
    id: 1025,
    name: "Sabawoon Super Fast Data Cable 1000mm USB-A to Type-C Charging Cable",
    price: 315,
    image: "/image/shop/Sabawoon Super Fast Data Cable 1000mm.png",
  },
  {
    id: 1026,
    name: "USB Mini LED Light – Portable High-Brightness Plug & Play Lamp for Laptops, Power Banks & Chargers",
    price: 150,
    image: "/image/shop/USB Mini LED Light.jpeg",
  },
  {
    id: 1027,
    name: "Vintage T9 Professional Trimmer – Close-Cutting T-Blade Hair Clipper for Men - Metal Body",
    price: 750,
    image: "/image/shop/Vintage T9 Professional Trimmer.jpg",
  },
  {
    id: 1028,
    name: "Bolt/ex 12V Router Power Bank – High-Performance UPS for Non-Stop Internet (3-4 Hours Backup) - 20000Mah Battery",
    price: 1560,
    image: "/image/shop/Boltex12VRouterPowerBank.png",
  },
  {
    id: 1029,
    name: "Premium Skull Headlamp for Honda CD70 & CG125 – Aggressive Red Skull DRL with Dual LED Projectors",
    price: 2205,
    image: "/image/shop/Premium Skull Headlamp for Honda CD70 & CG125.jpeg",
  },
  {
    id: 1030,
    name: "Fontec Glow Wireless Earbuds – Bluetooth 5.3 Gaming Earphones with ENC Noise Cancellation & Transparent Charging Case",
    price: 2583,
    image: "/image/shop/Fontec Glow Wireless Earbuds – Bluetooth 5.3 Gaming Earphones with ENC Noise Cancellation.png",
  },
  {
    id: 1031,
    name: "2-in-1 Mini Hair Straightener & Curler – Portable Thermostatic Ceramic Flat Iron for Dry & Wet Hair Styling - Random Color",
    price: 425,
    image: "/image/shop/Mini Hair Straightener & Curler.jpeg",
  },
  {
    id: 1032,
    name: "Digital Blood Pressure Monitor – Accurate BP & Pulse Checker DBP-1333",
    price: 5121,
    image: "/image/shop/Digital Blood Pressure Monitor – Accurate BP & Pulse Checker DBP-1333.jpg",
  },
];

const Shop = () => {


  const navigate = useNavigate();
  return (
    <>
          <TopBar />
          <Navbar />
     
    <div className="min-h-screen bg-slate-100">
     

      {/* Products Section */}
      <div className="max-w-7xl mx-auto px-4 py-10">
        <h2 className="text-3xl font-bold mb-8 text-slate-800">
          Featured Products
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden group"
            >
              {/* Product Image */}
              <div className="h-64 bg-gray-50 p-4 flex items-center justify-center">
                <img
                  src={product.image}
                  alt={product.name}
                  className="h-full w-full object-contain group-hover:scale-105 transition duration-300"
                />
              </div>

              {/* Product Details */}
              <div className="p-5">
                <h3 className="text-lg font-semibold text-slate-800 line-clamp-2 min-h-[56px]">
                  {product.name}
                </h3>

                <div className="flex items-center justify-between mt-4">
                  <span className="text-2xl font-bold text-orange-600">
                    Rs {product.price.toLocaleString()}
                  </span>
                </div>

                {/* <button className="w-full mt-5 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold py-3 rounded-lg transition duration-300">
                  Add to Cart
                </button> */}
                <button
                        onClick={() => navigate(`/product/${product.id}`)}
                        className="w-full mt-5 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold py-3 rounded-lg transition duration-300"
                        >
                        View Details
                        </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
     </>
  );
};

export default Shop;